//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            menus: []
        };
    },
    mounted() {
        this.getMenus();
    },
    methods: {
        getMenus() {
            this.axios({
                url: 'articleCategory/listTree',
                data: {
                    pid: 0
                }
            }).then((res) => {
                if (res) {
                    this.menus = res.data;
                }
            });
        }
    }
};
